// Refresh the gamification/points surfaces (Leaderboard, Performance, the
// My-Day points card) after a task completion. Completing/reopening a task
// awards or reverses points server-side, but the task-status mutations only
// invalidate the task lists — so the leaderboard relied SOLELY on the realtime
// socket (RealtimeInvalidator maps `task` → these same keys). When the socket
// isn't connected, points appeared stale until a manual reload. Calling this in
// a status-change mutation's success handler closes that gap belt-and-braces.
//
// React Query prefix-matches, so these three keys cover every gamification
// query: ['leaderboard', …], ['gamification', …] and ['gamification-me', …].
export function invalidateGamification(qc) {
  void qc.invalidateQueries({ queryKey: ['leaderboard'] })
  void qc.invalidateQueries({ queryKey: ['gamification'] })
  void qc.invalidateQueries({ queryKey: ['gamification-me'] })
  // Other surfaces that ALSO render a points total and otherwise lagged the
  // leaderboard — the rank/position moved but the number stayed stale until a
  // manual reload (QA: Company Admin edits priority points / a task is
  // completed). The employee Dashboard's overview card and the Performance
  // page both read points, so refresh them in lock-step with the leaderboard.
  void qc.invalidateQueries({ queryKey: ['me-dashboard-overview'] })
  void qc.invalidateQueries({ queryKey: ['performance'] })
}
